/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_register_already_have_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already have an account?`)
};

const zh_hans1_register_already_have_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已经有账号了？`)
};

const zh_hant1_register_already_have_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已經有帳戶了？`)
};

const fr_register_already_have_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez déjà un compte ?`)
};

const de_register_already_have_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hast du bereits ein Konto?`)
};

const ja_register_already_have_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すでにアカウントをお持ちですか？`)
};

const ko_register_already_have_account = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미 계정이 있으신가요?`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const register_already_have_account = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.register_already_have_account(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("register_already_have_account", locale)
	if (locale === "en") return en_register_already_have_account(inputs)
	if (locale === "zh-Hans") return zh_hans1_register_already_have_account(inputs)
	if (locale === "zh-Hant") return zh_hant1_register_already_have_account(inputs)
	if (locale === "fr") return fr_register_already_have_account(inputs)
	if (locale === "de") return de_register_already_have_account(inputs)
	if (locale === "ja") return ja_register_already_have_account(inputs)
	return ko_register_already_have_account(inputs)
};